import { Grid, RadioGroupInput } from '@kirz/mui-admin';
import React from 'react';

import { StepWrapper } from '../StepWrapper';

export default function Step() {
  return (
    <StepWrapper
      name="Buitenlandse bankrekeningen"
      description="Beschikt uzelf, uw partner en/of uw minderjarige kinderen over buitenlandse bankrekeningen?"
      maxWidth={1000}
      forwardStep={(data) => {
        if (data['has_foreign_bank_accounts'] === 'nee') {
          return 2;
        }

        return 1;
      }}
    >
      <Grid container spacing={4}>
        <RadioGroupInput
          name="has_foreign_bank_accounts"
          items={[
            { text: 'nee', value: 'nee' },
            { text: 'ja', value: 'ja' },
          ]}
          required
        />
      </Grid>
    </StepWrapper>
  );
}
